<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <base-alert class="mb-4" />
        <div class="card-outlined p-4">
          <h1 class="text-subtitle-underline">{{ t('account.change_name.title') }}</h1>
          <form @submit.prevent="onSubmit">
            <div class="mb-4">
              <label
                for="name"
                class="form-label"
              >
                {{ t('word.name') }}
              </label>
              <input
                v-model="name"
                id="name"
                name="name"
                type="text"
                :placeholder="t('word.name')"
                :class="`form-input mb-1 ${errors['name'] ? 'border-red-500' : ''}`"
              >
              <p class="form-error-text">{{ errors['name'] }}</p>
            </div>
            <div class="flex items-center pt-2">
              <base-form-submit :disabled="btnDisabled" :text="t('word.change')" />
            </div>
          </form>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { axios } from '@/plugins/axios'
import { ALERT_COLORS } from '@/store/base'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseAlert from '@/components/BaseAlert.vue'

type AccountChangeNameValues = {
  name: string
}

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BaseFormSubmit,
    BaseAlert
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues: AccountChangeNameValues = {
      name: store.state.user.user?.name ?? '',
    }

    const schema = yup.object({
      name: yup.string().required().max(255),
    })
    const { handleSubmit, errors } = useForm<AccountChangeNameValues>({
      validationSchema: schema,
      initialValues
    })
    const { value: name } = useField<string>('name')
    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-name', values)
        .then(response => {
          store.commit('user/setUser', response.data.payload)
          store.commit('base/setAlertMessages', { messages: [t('account.change_name.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      name,
      onSubmit,
      btnDisabled
    }
  }
})
</script>
